<template>
  <nav class="navbar" :class="{ 'navbar-scrolled': isScrolled }">
    <div class="logo">LAIQIU<span>来秋</span></div>

    <!-- 移动端汉堡按钮 -->
    <div class="hamburger" @click="showMenu = !showMenu" :class="{ active: showMenu }">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <!-- 导航链接 -->
    <div class="nav-links" :class="{ open: showMenu }">
      <router-link v-for="item in navList" :key="item.path" :to="item.path" class="nav-item" @click="closeMenu">
        {{ item.name }}
      </router-link>
    </div>

    <!-- 加入社区（唯一按钮） -->
    <button class="join-btn" @click="goToCommunity">
      <span class="btn-content">加入社区</span>
      <span class="btn-glimmer"></span>
      <div class="btn-particles">
        <span v-for="n in 3" :key="n"></span>
      </div>
    </button>
  </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'

const isScrolled = ref(false)
const showMenu = ref(false)
const route = useRoute()

const navList = ref([
  { name: '首页', path: '/' },
  { name: '探索', path: '/explore' },
  { name: '理念', path: '/philosophy' },
  { name: '数据', path: '/stats' },
  { name: '能力', path: '/tech' },
  { name: '伙伴', path: '/partners' },
  { name: '实验室', path: '/lab' },
  { name: '关于我们', path: '/about' },
])

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50
}
const closeMenu = () => {
  showMenu.value = false
}
const goToCommunity = () => {
  window.open('https://user.lqaqiu.xyz', '_blank')
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
:root {
  --bg: #050505;
  --text: #ffffff;
  --primary: #f3f3f3;
  --accent: #6d5dfc;
  --glass: rgba(255, 255, 255, 0.05);
  --border: rgba(255, 255, 255, 0.1);
  --accent-light: #a29bfe;
}

.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  padding: 1.5rem 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  transition: all 0.4s ease;
  box-sizing: border-box;
}

.navbar-scrolled {
  background: rgba(5, 5, 5, 0.8);
  backdrop-filter: blur(10px);
  padding: 1rem 4rem;
  border-bottom: 1px solid var(--border);
}

.logo {
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: 2px;
}

.logo span {
  font-weight: 300;
  margin-left: 8px;
  font-size: 1rem;
  opacity: 0.8;
}

/* ========================
   汉堡按钮（移动端）
========================= */
.hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  z-index: 9999;
}

.hamburger span {
  width: 24px;
  height: 2px;
  background: #fff;
  transition: 0.3s;
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* ========================
   导航链接
========================= */
.nav-links {
  display: flex;
  align-items: center;
}

.nav-links a {
  color: #fff;
  text-decoration: none;
  margin: 0 1.5rem;
  font-size: 0.9rem;
  opacity: 0.6;
  transition: all 0.3s;
}

.nav-links a.router-link-active {
  opacity: 1;
  color: var(--accent);
  font-weight: 600;
}

.nav-links a:hover {
  opacity: 1;
}

/* ========================
   按钮
========================= */
.join-btn {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0.7rem 1.8rem;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 1px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-content {
  position: relative;
  z-index: 2;
  transition: all 0.3s;
}

.btn-glimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1), transparent);
  transition: 0.6s;
  z-index: 1;
}

.join-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #6d5dfc;
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(109, 93, 252, 0.2), 0 0 12px rgba(109, 93, 252, 0.1);
  letter-spacing: 2px;
}

.join-btn:hover .btn-glimmer {
  left: 100%;
}

.join-btn:active {
  transform: translateY(0);
  background: #6d5dfc;
}

.btn-particles span {
  position: absolute;
  width: 2px;
  height: 2px;
  background: #6d5dfc;
  border-radius: 50%;
  opacity: 0;
  transition: 0.5s;
}

.join-btn:hover .btn-particles span:nth-child(1) {
  top: 10%;
  left: 10%;
  opacity: 1;
  transform: translate(-10px, -10px);
}

.join-btn:hover .btn-particles span:nth-child(2) {
  bottom: 10%;
  right: 10%;
  opacity: 1;
  transform: translate(10px, 10px);
}

.join-btn:hover .btn-particles span:nth-child(3) {
  top: 50%;
  right: -5px;
  opacity: 1;
  transform: translateX(10px);
}

/* ========================
   移动端适配（核心）
========================= */
@media (max-width: 992px) {
  .navbar {
    padding: 1rem 2rem;
  }

  .hamburger {
    display: flex;
  }

  .nav-links {
    position: fixed;
    top: 0;
    right: 0;
    width: 240px;
    height: 100vh;
    background: #0a0a0a;
    flex-direction: column;
    padding: 80px 0 30px;
    transform: translateX(100%);
    transition: 0.4s;
    border-left: 1px solid var(--border);
  }

  .nav-links.open {
    transform: translateX(0);
  }

  .nav-links a {
    margin: 1rem 0;
    font-size: 1rem;
  }

  .join-btn {
    display: none;
  }
}
</style>